import {
  Text,
  View,
  ScrollView,
  StyleSheet,
  ActivityIndicator
} from 'react-native'
import * as React from 'react'
// styles
import { globalStyles, fontPalette } from '../../../static/styles/global'
import Card from '../../../components/shared/card/Card'
import moment from 'moment'
import * as Progress from 'react-native-progress'
import { usepaycheckStore } from '../../../stores/paycheck'
import { useLabourStore } from '../../../stores/labour'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import HomeDetailsHeader from '../../../components/home/HomeDetailsHeader'

const EarningsScreen = ({ navigation, route }: any): JSX.Element => {

  const { t } = useTranslation()
  const [headerLabel, setHeaderLabel] = React.useState(t('Current Earnings'))
  const paycheckstore = usepaycheckStore()
  const labourstore = useLabourStore()
  const { params } = route
  const { mostRecentUserOnBoardings: Id, refresh, clockinStatusNum } = params

  // Gate: clockinStatusNum === 2 means employee is currently clocked IN (shift active)
  // Only show earnings data after clock-out (status 3) or when no active shift (1 / null)
  const isShiftActive = clockinStatusNum === 2

  useEffect(() => {
    const fetchData = async () => {
      try {
        await paycheckstore.fetchCurrentWeekEarnings(
          labourstore.labourData?.essUserKey,
          Id,
          labourstore.labourData?.employeeNumber,
          labourstore.labourData?.userId ? labourstore.labourData?.userId : 0
        )
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    fetchData()
  }, [])

  const [progresswidth, setProgresswidth] = React.useState(0)

  const find_dimesions = (layout: any) => {
    const { width } = layout
    setProgresswidth(width)
  }


  const sliceddata = paycheckstore?.currentweekData?.data

  const progress = (a, b) => {
    if (b == 0 || b == undefined) {
      return 0
    } else {
      return a / b
    }
  }

  const time = (a, b) => {
    const [hours, min] = a?.split(':').map(Number)
    const [hours1, min1] = b?.split(':').map(Number)
    const total = hours * 60 + min
    const total1 = hours1 * 60 + min1
    if (total1 == 0) {
      return 0
    } else {
      return total / total1
    }
  }
  return (
    <ScrollView>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader />
        </View>
        <View style={{ marginTop: 20, marginBottom: 0 }}>
          <Text
            style={{
              color: 'white',
              textAlign: 'center',
              fontFamily: fontPalette.primaryBold,
              fontSize: 24
            }}
          >
            {headerLabel}
          </Text>
        </View>
      </View>
      <View style={[globalStyles.containerOverlap]}>
        <Card>
          {paycheckstore?.loading ? (
            <ActivityIndicator></ActivityIndicator>
          ) : sliceddata ? (
            <>
              <View
                style={{
                  flexDirection: 'row',
                  flex: 1,
                  justifyContent: 'space-between'
                }}
              ></View>
              <View style={{ justifyContent: 'center', alignItems: 'center' }}>
                <Text
                  style={{
                    color: '#0B495C',
                    fontSize: 18,
                    fontFamily: fontPalette.primaryBold,
                    textAlign: 'center'
                  }}
                >
                  {moment(sliceddata?.startDate).format('MMMM D') +
                    ' - ' +
                    moment(sliceddata?.endDate).format('MMMM D YYYY')}
                </Text>
              </View>
              <View
                style={{
                  flexDirection: sliceddata?.payType == 'H' ? 'row' : "column",
                  justifyContent:
                    sliceddata?.payType == 'H' ? 'space-around' : 'flex-start',
                  marginTop: 30
                }}
              >
                <Text style={styles.title}>{t('ESTIMATED EARNED WAGES')}</Text>
                {sliceddata?.payType == 'H' ? (
                  <Text
                    style={{
                      flex: 1,
                      textAlign: 'right',
                      color: 'rgb(0, 75, 121)'
                    }}
                  >
                    {t('Potential')} $
                    {new Intl.NumberFormat('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    }).format(sliceddata?.potential)}
                  </Text>
                ) : (
                  <View style={globalStyles.mt2}>
                    <Text style={styles.salaryText}>{t('Salary Amount')} : ${sliceddata.salaryAmount}</Text>
                  </View>
                )}
              </View>
              {sliceddata?.payType == 'H' && (
                <>
                  <View
                    onLayout={(event) => {
                      find_dimesions(event.nativeEvent.layout)
                    }}
                    style={{ flex: 1, marginTop: 10 }}
                  >
                    <Progress.Bar
                      progress={progress(
                        sliceddata?.earned,
                        sliceddata?.potential
                      )}
                      width={progresswidth}
                      height={18}
                      color="rgb(0, 75, 121)"
                      style={{
                        // width: '100%',
                        borderRadius: 0,
                        // height: 20,
                        backgroundColor: 'rgb(193,193,193)',
                        borderWidth: 0
                      }}
                    />
                  </View>
                  <View
                    style={[{ marginTop: 10, flex: 1, flexDirection: 'row' }]}
                  >
                    <View
                      style={{
                        padding: 10,
                        backgroundColor: '#0B495C',
                        width: 10,
                        height: 10
                      }}
                    ></View>
                    <View style={{ flexDirection: 'row' }}>
                      <Text style={{ marginLeft: 10 }}>
                        {t('Earned')} $
                        {new Intl.NumberFormat('en-US', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        }).format(sliceddata?.earned)}
                      </Text>
                      <Text style={{ color: '#27A710' }}>
                        {' '}
                        {(
                          progress(sliceddata?.earned, sliceddata?.potential) *
                          100
                        ).toFixed(2)}{' '}
                        % {t('of Potential')}
                      </Text>
                    </View>
                  </View>
                  <View
                    style={[{ marginTop: 10, flex: 1, flexDirection: 'row' }]}
                  >
                    <View
                      style={{
                        padding: 10,
                        backgroundColor: 'rgb(193,193,193)',
                        width: 10,
                        height: 10
                      }}
                    ></View>
                    <Text style={{ marginLeft: 10 }}>
                      {t('Yet to earn')} $
                      {new Intl.NumberFormat('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      }).format(sliceddata?.yetToEarn)}
                    </Text>
                  </View>
                </>
              )}


              <Text style={{ color: "red", marginTop: 10, fontFamily: fontPalette.primaryRegular, }}>*{t('Amount does not include paid break earnings')}.*</Text>
              <View style={[{ marginTop: 20, flex: 1, flexDirection: 'row' }]}>
                <Text style={styles.title}>{t('TOTAL WORKING HOURS')}</Text>
                <Text
                  style={{
                    flex: 1,
                    textAlign: 'right',
                    color: 'rgb(0, 75, 121)'
                  }}
                >
                  Hrs. : {sliceddata?.hoursScheduled}
                </Text>
              </View>
              <View
                onLayout={(event) => {
                  find_dimesions(event.nativeEvent.layout)
                }}
                style={{ marginTop: 10, flex: 1 }}
              >
                <Progress.Bar
                  progress={time(
                    sliceddata?.hoursWorked,
                    sliceddata?.hoursScheduled
                  )}
                  width={progresswidth}
                  height={18}
                  color=" rgb(0, 153, 229)"
                  style={{
                    //width: '100%',
                    borderRadius: 0,
                    //height: 20,
                    backgroundColor: 'rgb(193,193,193)',
                    borderWidth: 0
                  }}
                />
              </View>
              <View style={{ marginTop: 10, flexDirection: 'row' }}>
                <View
                  style={{
                    padding: 10,
                    backgroundColor: '#0099E5',
                    width: 10,
                    height: 10
                  }}
                ></View>
                <Text style={{ marginLeft: 10 }}>
                  {t('Hours Worked')}: {sliceddata?.hoursWorked}
                </Text>
              </View>
              <View
                style={[
                  { marginTop: 10, flexDirection: 'row', marginBottom: 10 }
                ]}
              >
                <View
                  style={{
                    padding: 10,
                    backgroundColor: 'rgb(193,193,193)',
                    width: 10,
                    height: 10
                  }}
                ></View>
                <Text style={{ marginLeft: 10 }}>
                  {t('Scheduled Hours Remaining')} : {sliceddata?.hoursRemaining}
                </Text>
              </View>
              <View
                style={[
                  { marginTop: 5, flexDirection: 'row', marginBottom: 10 }
                ]}
              >
                <View
                  style={{
                    padding: 9,
                    backgroundColor: "#fff",
                    width: 10,
                    height: 10,
                    borderColor: "grey",
                    borderWidth: 1
                  }}
                ></View>

                <Text style={{ marginLeft: 10 }}>{t("Paid Break (Minutes)")} : {sliceddata?.paidBreakMinutes}</Text>
              </View>
              {isShiftActive && (
                <Text style={{ color: 'red', marginTop: 10, fontFamily: fontPalette.primaryRegular }}>
                  *{t('Open shift data will not display until the shift is completed.')}*
                </Text>
              )}
            </>
          ) : (
            <View style={{ justifyContent: 'center', alignItems: 'center' }}>
              <Text
                style={{
                  color: '#0B495C',
                  fontSize: 18,
                  fontFamily: fontPalette.primaryBold,
                  textAlign: 'center'
                }}
              >
                {t('No Earnings are available')}
              </Text>
            </View>
          )}
        </Card>
        <Card>
          <Text
            style={{ color: '#0099E5', textAlign: 'center', fontFamily: fontPalette.primaryRegular }}
            onPress={() => navigation.navigate('PayrollDocuments')}
          >
            {' '}
            {t('View All Payroll Documents')}
          </Text>
        </Card>
      </View>
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  myCard: {
    backgroundColor: 'white',
    borderRadius: 10
  },
  title: {
    fontFamily: fontPalette.primaryBold,
    fontSize: 16,
    color: 'rgb(0, 75, 121)'
  },
  textCenter: {
    textAlign: 'center',
    fontFamily: fontPalette.primaryRegular,
    fontSize: 14
  },
  header: {
    flexDirection: 'row',
    alignContent: 'center',
    width: '100%',
    padding: 15
  },
  paystubHeader: {
    flexDirection: 'row',
    marginTop: 20
  },
  salaryText: {
    fontSize: 14,
    color: 'rgb(0, 75, 121)',

  }
})
export default EarningsScreen
